import * as history from 'history';

export default history.createBrowserHistory();

// import createHistory from 'history/createBrowserHistory';

// export default createHistory();

